module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "title": "Modifier une ronde"
    },
    on: {
      "close": function($event) {
        _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "ronde-update"
  }, [(_vm.updateModal.message !== null) ? _c('div', {
    class: 'callout callout-' + _vm.updateModal.message.type
  }, [_c('p', [_vm._v(_vm._s(_vm.updateModal.message.text))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-4"
  }, [_vm._v("Nom")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ronde.nom),
      expression: "ronde.nom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ronde.nom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ronde, "nom", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-4"
  }, [_vm._v("Ronde BOM")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ronde.numero),
      expression: "ronde.numero"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ronde.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ronde, "numero", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-4"
  }, [_vm._v("Agent référent")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ronde.loginRef),
      expression: "ronde.loginRef"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ronde, "loginRef", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.sortedAgents), function(a) {
    return _c('option', {
      domProps: {
        "value": a.login
      }
    }, [_vm._v(_vm._s(a.login) + " - " + _vm._s(a.prenom) + " " + _vm._s(a.nom))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-4"
  }, [_vm._v("Agent planifié")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ronde.loginPla),
      expression: "ronde.loginPla"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ronde, "loginPla", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.sortedAgents), function(a) {
    return _c('option', {
      domProps: {
        "value": a.login
      }
    }, [_vm._v(_vm._s(a.login) + " - " + _vm._s(a.prenom) + " " + _vm._s(a.nom))])
  })], 2)])])]), _vm._v(" "), (!_vm.updateModal.canOnlyExitModal) ? _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.doUpdate()
      }
    }
  }, [_vm._v("Valider")])]) : _vm._e(), _vm._v(" "), (_vm.updateModal.loading) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_vm._v("\n      Chargement ...\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69786546!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/rondes/RondeUpdateModal.vue
// module id = 1874
// module chunks = 2